import React from 'react';
import { View } from 'react-native';
//= ========================================================================

const LineUnderPoint = ({
  globJSON,
  backgroundColor,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyle = {
    container: {
      width: 24, height: 24,
    },
    pointStyle: {
      width: 7,
      height: 7,
      marginBottom: 10,
      alignSelf: 'center',
      borderRadius: 3.5,
      backgroundColor: backgroundColor || colors.border_color,

    },
    lineStyle: {
      width: 20,
      height: 2,
      alignSelf: 'center',
      backgroundColor: backgroundColor || colors.border_color,
    },
  };
  return (
    <View style={myStyle.container}>
      <View style={myStyle.pointStyle} />
      <View style={myStyle.lineStyle} />
    </View>
  );
};
export default LineUnderPoint;
